import { THeaders } from '../../../types/request';
import { TGetPublishTermsModel, IGetPublishTermsRequestParams, TGetPublishTermsResponseSchema } from './internalTypes';
import { IGetPublishTermsParams } from './types';

const defaultConfig: TGetPublishTermsModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolithPython',
  pathApi: '/addform/v5/publish-terms/',
};

function createModel(parameters: IGetPublishTermsRequestParams): TGetPublishTermsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export async function getPublishTerms(dependencies: IGetPublishTermsParams): Promise<TGetPublishTermsResponseSchema> {
  const { httpApi, logger, telemetryService, cookies, parameters, subdomain } = dependencies;

  const headers: THeaders = cookies ? [['Cookie', cookies]] : [];

  const config = {
    requestConfig: { headers, withCredentials: true },
    subdomain,
  };

  try {
    telemetryService.mark('terms.publish-terms-start');

    const { response } = await httpApi.fetch(createModel(parameters), config);

    telemetryService.mark('terms.publish-terms-end');
    telemetryService.sendMeasuredTimer('terms.publish-terms-request', 'terms.publish-terms-start', 'terms.publish-terms-end');

    return response;
  } catch (error) {
    logger.error(
      error,
      {
        description: 'Запрос publish-terms на Форме подачи',
        degradation: 'Форма выбора услуг на ФП не отобразилась пользователю',
      },
    );

    return {
      data: {
        message: 'Что-то пошло не так',
      },
      status: 'internalServerError',
    };
  }
}
